import type { TFunction } from 'i18next';

const GIFT_CARD_SKU_RECOMMENDATIONS: Record<string, { key: string; count: number }> = {
  'gift-card-s3-sub-6m': { key: 'gift_card_recommendation_months', count: 6 },
  'gift-card-s3-sub-1y': { key: 'gift_card_recommendation_years', count: 1 },
  'gift-card-s3-sub-2y': { key: 'gift_card_recommendation_years', count: 2 },
};

export function getGiftCardRecommendation(sku: string, t: TFunction): string {
  const config = GIFT_CARD_SKU_RECOMMENDATIONS[sku];
  if (!config) return '';
  return t(config.key, { count: config.count });
}
